
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { generateMockLoans } from "@/utils/mockData";
import { toast } from "@/components/ui/use-toast";
import { Loan } from "@/types/borrower";

export const useLoans = () => {
  return useQuery({
    queryKey: ['active-loans'],
    queryFn: async () => {
      try {
        const { data: loansData, error } = await supabase
          .from('loan_applications')
          .select(`
            id,
            amount,
            purpose,
            status,
            risk_score,
            created_at,
            interest_rate,
            term_months,
            monthly_payment,
            total_amount,
            disbursement_date,
            next_payment_date,
            funding_progress,
            funding_goal,
            funding_deadline,
            story,
            category,
            profiles (
              first_name,
              last_name,
              phone_number,
              country
            ),
            collateral:collateral_properties(
              id,
              property_id,
              collateral_value,
              status
            )
          `)
          .eq('status', 'pending')
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Error fetching loans:', error);
          toast({
            title: "Error loading loans",
            description: "Using mock data instead",
            variant: "destructive",
          });
          return generateMockLoans(12);
        }

        if (!loansData || loansData.length === 0) {
          return generateMockLoans(12);
        }

        return loansData.map(loan => ({
          ...loan,
          borrower: {
            profile: loan.profiles || {
              first_name: null,
              last_name: null,
              phone_number: null,
              country: null
            }
          }
        })) as Loan[];
      } catch (error) {
        console.error('Error in loan query:', error);
        toast({
          title: "Error loading loans",
          description: "Using mock data instead",
          variant: "destructive",
        });
        return generateMockLoans(12);
      }
    },
  });
};
